import type { Ref } from 'vue'
import { ref, watch } from 'vue'
import { cloneDeep } from 'lodash-es'
import { useStore } from '@gx-vuex'
import { hanldeNewsDetails, getUUID, publicOpenDetails, getChinaTimeUix } from '@/utils/util'
import global from '@/common/global'
import { getDetailsSuggest } from '@/services/picDetails'
import { useUrlSearchParams } from '@vueuse/core'

export default function (returnCount = 10, type: 'suggest' | 'recommond'): Ref<NewsItem[]> {
  const store = useStore()
  const paramsUrls = useUrlSearchParams()

  const contentId = document.querySelector('body').getAttribute('data-id')
  const channelIds = document.querySelector('body').getAttribute('data-channelId')
  const objectType = document.querySelector('body').getAttribute('data-objectType')

  const dataSource = ref<NewsItem[]>([])

  const fetchList = async () => {
    const response = await getDetailsSuggest({
      url: type === 'suggest' || (!!store.global.details?.serials?.serialsId && objectType == '1')
        ? '/recommend/en/c/detail'
        : '/recommend/en/c/list',
      method: 'post',
      data: {
        returnCount,
        channelIds: channelIds ? channelIds?.split(',') || [] : [],
        contentId: Number(contentId),
        contentType: Number(objectType),
        imei: getUUID('PeoplesDaily')
      },
    })

    if (response) {
      dataSource.value = cloneDeep(response.data || []).map(item => {
        item.publishTime = getChinaTimeUix(!isNaN(Number(item.publishTime)) ? Number(item.publishTime) : item.publishTime).valueOf()
        const details = hanldeNewsDetails(item)
        details.newsLink = publicOpenDetails(details)
        store.point.contentListExposure(pointData(details))
        return details
      })
    }
  }

  watch(() => store.global.initContentState, (val) => {
    if (val === 1) {
      if (paramsUrls.promote == 'true') {
        return
      }
      fetchList()
    }
  })


  const pointData = (record: any) => {
    return {
      pageId: record?.mainChannel?.pageId,
      newsType: record.objectType,
      newsId: record.objectId,
      appstyle: record.appStyle,
      link_url: record.linkUrl,
      live_type: !!record.liveInfo ? global.live_type_change[record.liveInfo?.liveState] || '' : '',
      live_stream_type: !!record.liveInfo ? record.liveInfo?.vrType == '1' ? '2' : '1' : '',
      live_mode: !!record.liveInfo ? record.liveInfo?.tplId == '6' ? '2' : '1' : '',
      vlive_id: !!record.liveInfo ? record.liveInfo?.vlive?.[0]?.vliveId || '' : '',
      vlive_name: !!record.liveInfo ? record.liveInfo?.vlive?.[0]?.name || '' : '',
      newsTitle: record.newsTitle,
      secondId: record.channelList?.[1]?.channelId || '',
      channelId: record?.mainChannel?.channelId || '',
      author_name: record.newsAuthor,
      summary_type: record.objectType == '5' ? record?.objectLevel == 14
        ? global.summary_type.normal_subject
        : record?.objectLevel == 16
          ? 'thematic_subject' : record?.objectType == 16 ? 'author_subject' : '' : '',
      summary_id: record.objectType == '5' ? record.objectId : '',
      sceneId: record.sceneId,
      traceId: record.traceId,
      traceInfo: record.traceInfo
    }
  }

  return dataSource
}
